export default [
  {
    path: '/bulk_email',
    name: 'BulkEmail',
    component: () =>
      import('@/modules/uploadCSV/pages/findEmail/EmailFinderUploadCSV.vue'),
    meta: {
      authRequired: true,
      pageTitle: 'Bulk Email Finder',
      breadcrumb: [
        {
          text: 'Bulk Email Finder',
          active: true,
        },
      ],
    },
  },
  {
    path: '/bulk_map/:id',
    name: 'BulkMap',
    component: () =>
      import('@/modules/uploadCSV/pages/findEmail/EmailFinderUploadCSV.vue'),
    meta: {
      authRequired: true,
      pageTitle: 'Bulk Map',
      breadcrumb: [
        {
          text: 'Map Columns',
          active: true,
        },
      ],
    },
  },
  {
    path: '/bulk_list',
    name: 'BulkList',
    component: () =>
      import(
        '@/modules/uploadCSV/pages/findEmail/EmailFinderUploadCSVBulkList.vue'
      ),
    meta: {
      authRequired: true,
      pageTitle: 'Bulk List',
      breadcrumb: [
        {
          text: 'Bulk Emails List',
          active: true,
        },
      ],
    },
  },
];
